import calculateDistance from '../../../../Common/js/util/distanceCalculator';
import { GoogleMapsLocation } from '../../../../Common/modules/google-maps/google-maps-places';

if ($('#PostcodeOrSuburb').length) {
  $('#PostcodeOrSuburb').on('keyup', function () {
    autocomplete(this.value, $('.image-form__form--postcode').data('endpoint'));
  });

  $('#PostcodeOrSuburb').on('focus', function () {
    autocomplete(this.value, $('.image-form__form--postcode').data('endpoint'));
  });

  $(document).on('click', '.autocomplete button', function (e) {
    e.preventDefault();
    $('#PostcodeOrSuburb').val(e.currentTarget.textContent) 
    $('#PostcodeOrSuburb').data("placeid" ,e.currentTarget.dataset.branchId);
    $('.image-form__form--postcode .autocomplete').remove();
  });

  $('#PostcodeOrSuburb').on('focusout', function (e) {
    if (e.relatedTarget == null && $('.image-form__form--postcode .autocomplete')) {
      setTimeout(function () {
        $('.image-form__form--postcode .autocomplete').remove();
      }, 200);
    }
  });

  function autocomplete(keyword, endpoint) {
    if ($('.image-form__form--postcode .autocomplete')) {
      $('.image-form__form--postcode .autocomplete').remove();
    }

    if (keyword.length > 1) {
      var locationSearcher = new GoogleMapsLocation();
      locationSearcher.SearchForLocation(keyword, displaySuggestions);
    }
  }

  function displaySuggestions(predictions, status) {
    if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
      console.log("google.maps.places not ready...");
      return;
    }
    var html = "<ul class='autocomplete'>";

    var maxResults = 5;
    if (predictions != null) {
      predictions.slice(0,maxResults).forEach((subBranch) => {
        html += "<li class='autocomplete-item'><button class='autocomplete-button' data-branch-id='" + subBranch.place_id + "'" + ">" + subBranch.description + "</button></li>";
      });

      html += "</ul>";
      $('.image-form__form--postcode .form-textfield').append(html);
      Promise.resolve();
    }
  }
};

//Retrieve the 3 closest sub branches.
$('.js-sub-branch--submit').on('click', function (e) {

  e.preventDefault();
  const $formParent = $('.js-sub-branch--submit').parents('.image-form');
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ placeId: $formParent.find('#PostcodeOrSuburb').data("placeid") }, (results, status) => {
    if (status !== "OK" || !results || !results[0]) {
      console.log("Geocoder failed due to: " + status);
      $('.image-form__results-error').text("Something went wrong. Try again later.");
      $('.image-form__results-error').fadeIn();
      return { prediction: predictions[0], results: null };
    }
    var nearestSubBranches = matchPredictionToNearestSubbranch(results[0], 3);
    $('.image-form__results-error').text("");
    $('.image-form__results-error').fadeOut();
    showResults(nearestSubBranches);
  });
  
  function matchPredictionToNearestSubbranch(result, amount = 3) {
    var sortedSubBranches = [];
    if (!window.jsonSearchIndex.SubBranchDirectory || !window.jsonSearchIndex) {
      return null;
    }

    window.jsonSearchIndex.SubBranchDirectory.forEach((e) => {
      if (!e || !e.Location) {
        return null;
      }

      var lat1 = result.geometry.location.lat();
      var lng1 = result.geometry.location.lng();
      var lat2 = parseFloat(e.Location.split(",")[0]);
      var lng2 = parseFloat(e.Location.split(",")[1]);
      var distance = calculateDistance(lat1, lng1, lat2, lng2);
      sortedSubBranches.push({ id: e.BranchID, title: e.Title, distance: distance, city: e.AddressCity, state: e.AddressState, postcode: e.AddressPostCode, address: e.AddressLine1, phone:e.ContactPhone, email: e.ContactEmail, url: e.PageUrl, image: e.MobileBannerImage });
    });

    return sortedSubBranches.sort((el1, el2) => { return el1.distance - el2.distance }).slice(0, amount);
  }

 
  const showResults = function (subBranchFinderList) {
    const $results = $formParent.find('.js-image-form__results');
    $results.addClass('-show')

    const $resultsRow = $formParent.find('.js-image-form__results > .listing--feature > .row');
    $resultsRow.empty();
    $.when(
      $.each(subBranchFinderList, function (key, subbranch) {
        var url = /[^/]*$/.exec(subbranch.url)[0];

        let cardElement =
          `<div class="listing--feature-card listing--feature-card--subbranch">
        <a href="/about-us/${url}" class="card">
          <div class="card__image-wrapper">
              <img class="card__image" src="${subbranch.image.Src}" alt="${subbranch.image.Alt}">
              <div class="card__image-overlay"></div>
          </div>
          <div class="card__text">
            <div class="card__text-overlay">
            </div>
            <div class="card__title js-card__data--title">
              ${subbranch.title}
            </div>
            <dl class="card__data">
              <dt>Address:</dt>
              <dd>${subbranch.address}</dd>
              <dt>Phone:</dt>
              <dd>${subbranch.phone}</dd>
              <dt>Email:</dt>
              <dd>${subbranch.email}</dd>
            </dl>
          </div>
        </a>
      </div>`;
        $resultsRow.append(cardElement);
      })
    ).then(function () {
      //reveal cards with animation
      let $resultsCards = $formParent.find('.listing--feature-card--subbranch');
      let $resultsCardsText = $formParent.find('.card__text');
      $resultsCards.addClass('-show');
    })
  }
})
